import { useEffect } from 'react';

const useFavicon = (url) => {
  useEffect(() => {
    if (!url) return;

    let link = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = url;

    // Cleanup if needed (optional)
    return () => {
      // Optionally revert or remove favicon here if needed
    };
  }, [url]);
};

export default useFavicon;
